import { Routes } from '@angular/router';
import {
  ApplicantDataSectionComponent,
  ApplicantDataComponentConfig
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataSectionComponent,
  ApplicationDataComponentConfig
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataSectionComponent,
  AgreementsDataComponentConfig
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  NotificationOfEmergencyOccupationDataSectionComponent
} from './sections/notification-of-emergency-occupation-data-section/notification-of-emergency-occupation-data-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Wykonawca',
  'Zajęcia',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  applicationSubjectControlType: 'text',
  cancelUrl: '../wnioskodawca',
  successUrl: '../inwestor'
};

export const inwestorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../wykonawca',
  customTitles: {
    tag: 'investor',
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    cardTitle2: 'Edytuj inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const performerDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../inwestor',
  successUrl: '../dane-zajecia',
  customTitles: {
    tag: 'performer',
    sectionTitle: 'Wykonawca',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane wykonawcy',
      acceptLabel: 'Dane wykonawcy są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie wykonawcy',
    cardTitle2: 'Edytuj wykonawcę',
    addBtnTitle: 'Dodaj wykonawcę',
    addBtn2Title: 'Dodaj kolejnego wykonawcę',
    noDataInfo: 'Brak dodanych wykonawców!'
  }
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  successUrl: '../zalaczniki',
  cancelUrl: '../dane-zajecia'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const notificationOfEmergencyRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/inwestor',
    data: inwestorDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/wykonawca',
    data: performerDataSectionConfig
  },
  {
    component: NotificationOfEmergencyOccupationDataSectionComponent,
    path: ':appId/dane-zajecia'
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
